
export default {
  name: 'StartTradingSteps',
  props: {
    product: {
      type: String,
      default: ''
    }
  }
};  
